import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '../index.css';
import App from './App';
import { AppProviders } from './providers/AppProviders';
import { initI18n } from '@app/i18n';
import { isModuleEnabled } from '@app/config/env';
import { registerModule } from '@core/router/moduleRegistry';
import { documentArchiveModule } from '@modules/documentArchive';
import { fleetsModule } from '@modules/fleets';
import { usersModule } from '@modules/users';
import { humanResourcesModule } from '@modules/humanResources';

// Register all modules, except those disabled for this environment (VITE_DISABLED_MODULES).
// A module that is not registered has no routes, navigation or module-chooser tile.
const registerModules = () => {
  [
    documentArchiveModule,
    fleetsModule,
    usersModule,
    humanResourcesModule,
    // Add more modules here as they are created
  ]
    .filter((module) => isModuleEnabled(module.name))
    .forEach(registerModule);
};

const bootstrap = async () => {
  // Register modules
  registerModules();

  // Initialize i18n
  await initI18n();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </StrictMode>
  );
};

void bootstrap();
